
//提交表单时，后端验证不通过，将验证错误转换成前端的格式
export function transformError(error = {}) {
    let newError = {}
    for (let i in error) {
        if (error[i] instanceof Array) {
            newError[i] = error[i].join(',')
        } else if (typeof error[i] === 'string') {
            newError[i] = error[i]
        }
    }
    return newError
}